/* ICON WRAPPER — EVERY ICON INHERITS THE CURRENT TEXT COLOR */
const Icon = ({ size = 16, width = 2, children }) => (
    <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke="currentColor" strokeWidth={width} strokeLinecap="round" strokeLinejoin="round">
        {children}
    </svg>
)


/* CLOSE ICON */
export const CloseIcon = ({ size }) => (
    <Icon size={size}>
        <path d="M18 6 6 18M6 6l12 12" />
    </Icon>
)

/* CHECK ICON */
export const CheckIcon = ({ size = 12 }) => (
    <Icon size={size} width={3.5}>
        <path d="M20 6 9 17l-5-5" />
    </Icon>
)

/* SEARCH ICON */
export const SearchIcon = ({ size = 16 }) => (
    <Icon size={size}>
        <circle cx="10.8" cy="10.8" r="6.8" />
        <path d="M20.5 20.5 15.7 15.7" />
    </Icon>
)

/* EDIT ICON */
export const EditIcon = ({ size }) => (
    <Icon size={size}>
        <path d="M11 4H7a2 2 0 0 0-2 2v11a2 2 0 0 0 2 2h11a2 2 0 0 0 2-2v-4" />
        <path d="M18.5 2.5a2.12 2.12 0 0 1 3 3L12 15l-4 1 1-4Z" />
    </Icon>
)

/* EYE ICON — THE REPORT OPENS IN A MODAL */
export const EyeIcon = ({ size = 16 }) => (
    <Icon size={size}>
        <path d="M2.5 12S6 5.5 12 5.5 21.5 12 21.5 12 18 18.5 12 18.5 2.5 12 2.5 12Z" />
        <circle cx="12" cy="12" r="3" />
    </Icon>
)

/* LOCK ICON — NOT A SUPERADMIN, NOTHING CHANGES */
export const LockIcon = ({ size = 14 }) => (
    <Icon size={size}>
        <rect x="4" y="11" width="16" height="10" rx="2" />
        <path d="M8 11V7a4 4 0 0 1 8 0v4" />
    </Icon>
)

/* INFO ICON — THE HINT OF A SECTION */
export const InfoIcon = ({ size = 16 }) => (
    <Icon size={size}>
        <circle cx="12" cy="12" r="9" />
        <path d="M12 11v5M12 7.6v.6" />
    </Icon>
)

/* REPORT ICON — THE XML PACKAGE SENT TO THE REGULATOR */
export const ReportIcon = ({ size = 20 }) => (
    <Icon size={size}>
        <path d="M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8Z" />
        <path d="M14 3v5h5" />
        <path d="M8.5 13h7M8.5 16.5h4.5" />
    </Icon>
)

/* DOWNLOAD ICON — THE XML FILE LEAVES THE PANEL */
export const DownloadIcon = ({ size = 14 }) => (
    <Icon size={size}>
        <path d="M12 3.5v11M7.5 10.5 12 15l4.5-4.5" />
        <path d="M4.5 19.5h15" />
    </Icon>
)

/* TABLE ICON — A TABLE OF THE STUDIO */
export const TableIcon = ({ size = 13 }) => (
    <Icon size={size}>
        <rect x="2.5" y="4.5" width="19" height="12" rx="4" />
        <path d="M8 20h8M12 16.5V20" />
    </Icon>
)

/* STUDIO ICON — THE GROUP OF A TABLE */
export const StudioIcon = ({ size = 13 }) => (
    <Icon size={size}>
        <rect x="3" y="4.5" width="18" height="12.5" rx="2.5" />
        <path d="M7 21h10M12 17v4" />
    </Icon>
)

/* CALENDAR ICON — THE PERIOD OF A REPORT */
export const CalendarIcon = ({ size = 13 }) => (
    <Icon size={size}>
        <rect x="3.5" y="5" width="17" height="15.5" rx="3" />
        <path d="M3.5 10h17M8.5 3v4M15.5 3v4" />
    </Icon>
)

/* CLOCK ICON — THE MOMENT THE PACKAGE LEFT */
export const ClockIcon = ({ size = 13 }) => (
    <Icon size={size}>
        <circle cx="12" cy="12" r="8.5" />
        <path d="M12 7.5V12l3.5 2" />
    </Icon>
)

/* HASH ICON — THE SIGNATURE OF A SENT PACKAGE */
export const HashIcon = ({ size = 13 }) => (
    <Icon size={size}>
        <path d="M9.5 3.5 7.5 20.5M16.5 3.5l-2 17M4 8.5h16M3 15.5h16" />
    </Icon>
)

/* SEND ICON — THE STATE OF A REPORT */
export const SendIcon = ({ size = 13 }) => (
    <Icon size={size}>
        <path d="M21 3 10.5 13.5" />
        <path d="M21 3l-6.5 18-4-7.5L3 9.5Z" />
    </Icon>
)

/* CHART ICON — THE MONEY OF A REPORT */
export const ChartIcon = ({ size = 13 }) => (
    <Icon size={size}>
        <path d="M4 20V4M4 20h16" />
        <path d="M8.5 20v-6M13 20V9.5M17.5 20v-9" />
    </Icon>
)

/* GAME ICON — ONE GAME LINE OF A REPORT */
export const GameIcon = ({ size = 13 }) => (
    <Icon size={size}>
        <path d="M12 3.5 20 12l-8 8.5L4 12Z" />
    </Icon>
)

/* COPY ICON — THE HASH GOES TO THE CLIPBOARD */
export const CopyIcon = ({ size = 14 }) => (
    <Icon size={size}>
        <rect x="9" y="9" width="11" height="11" rx="2.5" />
        <path d="M15 5.5A2.5 2.5 0 0 0 12.5 3H6.5A2.5 2.5 0 0 0 4 5.5v6A2.5 2.5 0 0 0 6.5 14" />
    </Icon>
)

/* KEY ICON — THE GAME ID GIVEN BY THE REGULATOR */
export const KeyIcon = ({ size = 14 }) => (
    <Icon size={size}>
        <circle cx="8" cy="15.5" r="3.5" />
        <path d="M10.5 13 20 3.5M17 3.5h3v3" />
    </Icon>
)

/* BAN ICON — A TABLE LEFT OUT OF THE REPORTS */
export const BanIcon = ({ size = 13 }) => (
    <Icon size={size}>
        <circle cx="12" cy="12" r="8.5" />
        <path d="M6 18 18 6" />
    </Icon>
)
